import React, { useContext, useState } from 'react'
import ProfilesPage from '.'
import Profiles2 from './Profiles2'
import { IconButtonGroups } from 'styles/GlobalStyle'
import { IconButtons, Switch } from 'components/Form'
import { useQuery } from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import { getProfilesByCategoriesFetch, getStudentBatteriesProfilesFetch } from 'store/middlewares/assessment.crud'
import ProfilesByCategory from './ProfilesByCategory'
import qc from 'keys/queryClient'
import { AssessmentsContext } from 'pages/School/Assessments/AssessmentsContext'

const profileBtns = [{ label: "מבט כללי", key: "BASIC", Component: Profiles2 }, { key: "CATEGORIES", label: "תצוגה מפורטת", Component: Profiles2 }]

const WrapProfiles = () => {
    const { headerFilters } = useSelector(state => state.header)
    const { testTaker } = useSelector(state => state.testTaker)
    const { profileFilters: filters, setProfileFilters: setFilters } = useContext(AssessmentsContext)

    const [visibleRatings, setVisibleRatings] = useState({ "1": false, "2": false, "3": true, "4": true, "5": true })
    const [viewType, setViewType] = useState(profileBtns[0].key)
    const [showDetails, setShowDetails] = useState(false)

    const profilesByCategories = useQuery({
        queryKey: [qc.profiles, "student_batteries", headerFilters, testTaker, filters],
        queryFn: async () => {
            const { data } = await getProfilesByCategoriesFetch({ headerFilters, testTaker, assessmentFilters: filters })
            return data
        },
        enabled: viewType != 'BASIC'
    })

    return (
        <ProfilesPage
            setFilters={setFilters}
            filters={filters}
            visibleRatings={visibleRatings}
            showDetails={showDetails}
            setVisibleRatings={setVisibleRatings}
            customToolbar={
                <div className='view-options-btns'>
                    <Switch
                        label="פרטי כיתה"
                        input={{
                            value: showDetails,
                            onChange: setShowDetails
                        }} />
                    <IconButtonGroups>
                        <IconButtons
                            btns={profileBtns}
                            setSelected={(e, val) => setViewType(val)}
                            selected={viewType}
                        />
                    </IconButtonGroups>
                </div>}
            title="מצב התלמידים בחלוקה לפי תחומי קריאה"
            subTitle={() => "כאן התלמידים מחולקים לפי רמות הביצוע שלהם באבני יסוד ובשטף קריאה, עם פירוט שמראה מה כבר מבוסס ומה עדיין צריך חיזוק."}
        >
            {viewType == 'BASIC' ? <Profiles2 /> : <ProfilesByCategory data={profilesByCategories} />}
        </ProfilesPage>
    )
}

export default WrapProfiles